import React from 'react';
const stats = [['500+', 'PE Teachers'], ['6 + 5', 'Volumes & Bonuses'], ['4.9/5', 'Average rating'], ['Worldwide', 'Trusted globally']];
const notes = [['“I planned my entire school year in a single evening. Now every PE lesson has a clear objective and my students actually look forward to class.”', 'James R.', 'Primary PE Teacher'], ['“My students are improving so much faster now that they finally follow a logical skill progression. This changed everything.”', 'Coach Mike', 'Middle School PE Teacher'], ['“I no longer spend hours on YouTube hunting for activities. I open P.E. READY 360 and it is all there. Everything. Ready to go.”', 'Sarah L.', 'High School PE Teacher']];
export function ProofSection() {
  return <section className="bg-[#09281d] px-5 pb-16" data-id="element-188" data-mp="3sr116c51v7ip">
      <div className="mx-auto max-w-6xl" data-id="element-189" data-mp="3ssc4kaul2d9a">
        <div className="grid grid-cols-2 border border-emerald-300/25 bg-[#10372a] sm:grid-cols-4" data-id="element-190" data-mp="1joj7uwceq1q">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-emerald-300/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-191" data-mp="15p2v9bxf5yjj">
              <p className="font-display text-4xl font-bold uppercase text-emerald-300 sm:text-5xl" data-id="element-192" data-mp="vqdclgxp8a28">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-slate-300" data-id="element-193" data-mp="rptfgdd4l6g3">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-194" data-mp="1jfoitdxtiwnr">
          {notes.map(([quote, name, role]) => <figure key={name} className="flex flex-col border border-emerald-950/10 bg-white p-6" data-id="element-195" data-mp="1em3ivgcnzslx">
              <div className="mb-4 text-amber-500" aria-label="5 out of 5 stars" data-id="element-196" data-mp="2750r8blbn0p0">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-[#09281d]" data-id="element-197" data-mp="22bxslp1ot11y">
                {quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-emerald-950/10 pt-4 text-sm font-bold text-[#09281d]" data-id="element-198" data-mp="5e096182bwi1">
                {name}
                <span className="ml-2 text-xs font-medium text-slate-600" data-id="element-199" data-mp="3mtywop3oe4cq">
                  {role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}